<template>
  <cube-divider />
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({})
</script>

<style lang="stylus">
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-divider": "@mpxjs/mpx-cube-ui/src/components/divider/index"
    }
  }
</script>